<div class="radio-buttons-container">
    <mat-radio-group [formControl]="control">
        <div *ngFor="let item of details"
            [ngClass]="{'radio-buttons':true, 'active': control.value == item.value}">
            <mat-radio-button [value]="item.value" [disabled]="item.disabled" [checked]="item.checked || control.value == item.value" disableRipple>
                <div class="rd-text">
                    {{item.text}}
                    <span *ngIf="!!item.hint" class="hint">{{item.hint}}</span>
                </div>
            </mat-radio-button>
        </div>
    </mat-radio-group>
    <mat-error *ngIf="control.hasError('required')">
        Required
    </mat-error>
</div>
